import React, { PureComponent } from 'react'
import { Button, ButtonGroup } from 'react-bootstrap'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { fetchBusinessById, resetFetchBusinessById } from '../../actions/business'
import { fetchBusinessIdentitiesById } from '../../actions/business_identities'
import { fetchBusinessSettings } from '../../actions/business_settings'
import BusinessConfirmationModal from '../business_confirmation_modal'
import {
  cancelModalConfirmation,
  closeModalConfirmation,
  openModalConfirmation,
} from '../../actions/modal_confirmation'
import { businessUpdateTxState } from '../../actions/business_update_tx_state'
import {
  __isEnvDev,
  BUSINESS_STATUS_ACCEPTED,
  BUSINESS_STATUS_HOLD,
  TX_STATUS_COMPLETED,
  TX_STATUS_HOLD,
} from '../../config'
import { fetchUserTxById } from '../../actions'
import SpinnerCircle from '../spinner_circle'
import styles from '../css/spinner_circle_green.css'
import { businessRestart } from '../../actions/business_restart'

class BusinessTxDetailsButtons extends PureComponent {
  constructor(props) {
    super(props)
    this.state = { uboCompleteCount: null, loading: true }
  }

  fetchUserTx = (i, data, acc, f) => {
    if (data.length === acc.length) {
      this.setState({
        loading: false,
        uboCompleteCount: acc.filter((s) => s === TX_STATUS_COMPLETED).length,
      })
      return acc
    }
    Promise.resolve(f(data[i].transaction))
      .then((res) => {
        acc.push(res.response.state)
        return this.fetchUserTx(i++, data, acc, f)
      })
      .catch((reason) => {
        if (__isEnvDev) {
          console.log(reason)
        }
      })
  }

  componentDidMount() {
    const { fetchUserTxById, data } = this.props
    this.fetchUserTx(0, data, [], fetchUserTxById)
  }

  attemptApprove = () => {
    const { data } = this.props
    if (this.state.uboCompleteCount !== data.length) {
      window.alert('All ' + data.length + ' UBO(s) must be approved first!')
      return
    }
    this.props.attemptApprove(this.openModalApprove)
  }

  openModalApprove = () => this.props.openModalConfirmation('accepted')

  onCloseModal = () => {
    const { id, fetchBusinessById, resetFetchBusinessById, fetchBusinessIdentitiesById, fetchBusinessSettings } =
      this.props
    resetFetchBusinessById()
    fetchBusinessById(id)
    fetchBusinessIdentitiesById(id)
    fetchBusinessSettings(id)
    this.props.closeModalConfirmation()
  }

  onRestartBusiness = async () => {
    const {
      id,
      businessRestart,
      fetchBusinessById,
      resetFetchBusinessById,
      fetchBusinessIdentitiesById,
      fetchBusinessSettings,
    } = this.props
    await businessRestart(id)
    resetFetchBusinessById()
    fetchBusinessById(id)
    fetchBusinessIdentitiesById(id)
    fetchBusinessSettings(id)
  }

  render() {
    const {
      openModalConfirmation,
      isModalConfirmationOpen,
      id,
      cancelModalConfirmation,
      currentState,
      businessData,
      isRestart,
    } = this.props

    const errors = businessData.errors.find((i) => i.error_code.error_code_id === 1009)
    if (this.state.loading) {
      return (
        <div style={{ height: '32px' }} className='m-b m-t animated fadeIn'>
          <div style={{ marginBottom: '4px' }} className='text-center'>
            <SpinnerCircle isActive styles={styles} />
          </div>
        </div>
      )
    }
    if (currentState === BUSINESS_STATUS_ACCEPTED) {
      return (
        <div className='m-b m-t animated fadeIn'>
          <ButtonGroup className='shadow'>
            <Button
              className='text-center'
              style={{ backgroundColor: '#A9A9A9', color: 'white' }}
              bsPrefix='btn btn-w-m '
              size={'lg'}
              onClick={() => openModalConfirmation(TX_STATUS_HOLD)}
            >
              <i className='fa fa-pause' /> Hold
            </Button>
          </ButtonGroup>
          <BusinessConfirmationModal
            id={id}
            isModalConfirmationOpen={isModalConfirmationOpen}
            title='Confirm'
            close={this.onCloseModal}
            cancel={cancelModalConfirmation}
          />
        </div>
      )
    } else if (
      currentState === BUSINESS_STATUS_HOLD &&
      errors &&
      errors.error_code &&
      errors.error_code.error_code_id === 1009 &&
      errors.is_active
    ) {
      return (
        <div className='m-b m-t animated fadeIn'>
          <ButtonGroup className='shadow'>
            <Button
              className='text-center'
              bsClass='btn btn-w-m btn-success'
              size={'lg'}
              onClick={() => this.onRestartBusiness()}
            >
              <i className={`fa fa-refresh ${isRestart ? 'fa-spin' : ''}`} /> Run AML
            </Button>
          </ButtonGroup>
        </div>
      )
    }
    return (
      <div className='m-b m-t animated fadeIn'>
        <ButtonGroup className='shadow'>
          <Button bsPrefix='btn btn-w-m btn-danger' onClick={() => openModalConfirmation('rejected')}>
            <i className='fa fa-exclamation-triangle' /> Decline
          </Button>
          <Button bsPrefix='btn btn-w-m btn-primary' size={'lg'} onClick={() => this.attemptApprove()}>
            <i className='fa fa-check' />
            Approve
          </Button>
        </ButtonGroup>
        <BusinessConfirmationModal
          id={id}
          isModalConfirmationOpen={isModalConfirmationOpen}
          title='Confirm'
          close={this.onCloseModal}
          cancel={cancelModalConfirmation}
        />
      </div>
    )
  }
}
const mapStateToProps = (state) => ({
  isModalConfirmationOpen: state.modalConfirmation.isModalConfirmationOpen,
  newState: state.modalConfirmation.newState,
  isRestart: state.businessRestart.isFetching,
})

const mapDispatchToProps = (dispatch, ownProps) =>
  bindActionCreators(
    {
      openModalConfirmation,
      closeModalConfirmation,
      cancelModalConfirmation,
      businessUpdateTxState,
      fetchUserTxById,
      fetchBusinessById,
      resetFetchBusinessById,
      fetchBusinessSettings,
      fetchBusinessIdentitiesById,
      businessRestart,
      navigateHome: () => ownProps.history.push('/'),
    },
    dispatch
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BusinessTxDetailsButtons))
